export const FLASH_KEYFRAMES: Keyframe[] = [
	{ backgroundColor: 'var(--mui-palette-primary-lighter)' },
	{ backgroundColor: 'transparent' }
];

export const FLASH_TIMING: KeyframeAnimationOptions = {
	duration: 1500,
	easing: 'ease-out'
};

export const dcrFieldStyles = {
	flashable: {
		borderRadius: 1,
		m: -1,
		p: 1
	}
};
